export enum AddressSettings {
  POSTBOX_TYPE = 'f9316480-5f2d-425d-bc2c-ac7cd29decf0',
}

export enum ControlModes {
  MODE = 'mode',
  TYPE = 'type',
  DATA = 'data',
}
